import React from "react";
import Authenticate from "./auth/Authenticate";
import DeviceCheck from "./validate/DeviceCheck";
import FaceContext from "./context/FaceContext";
import OCRContext from "./context/OCRContext";
import Router from "./router/Router";
import "./App.css";
// eslint-disable-next-line
import "usebeauty/dist/styles.css";

function App() {
  return (
    <Authenticate>
      <OCRContext.Provider>
        <FaceContext.Provider>
          <DeviceCheck>
            <Router />
          </DeviceCheck>
        </FaceContext.Provider>
      </OCRContext.Provider>
    </Authenticate>
  );
}

export default App;
